import type { ArticleRow } from "../api/client";
import { SearchBox } from "../components/SearchBox";
import { TopArticlesTable } from "../components/TopArticlesTable";

export function ArticlesPage({
  rows,
  search,
  onSearch
}: {
  rows: ArticleRow[];
  search: string;
  onSearch: (value: string) => void;
}) {
  return (
    <div className="page-stack">
      <div className="toolbar-row article-list-toolbar">
        <h2>文章排行</h2>
        <SearchBox
          value={search}
          label="搜尋文章"
          placeholder="搜尋標題、作者、文章 ID 或網址"
          onChange={onSearch}
        />
      </div>
      <section className="panel">
        <TopArticlesTable rows={rows} />
      </section>
    </div>
  );
}
